/* Use-case hub length (v5, Oct 19, 2026): at every width the first twelve cards show and the "Show all" row after them shows the rest (closed at load). A search or a filter shows them too, so a match is never hidden. All cards sit in ONE list (#uc-grid). Without this script every card shows. */
(function () {
  'use strict';
  var dir = document.querySelector('.uc-dir');
  var btn = dir && dir.querySelector('.uc-showall');
  if (!dir || !btn) return;
  var q = document.getElementById('uc-q');
  var manual = false;
  var sync = function () {
    var forced = !!window.__ucActive || !!(q && q.value.trim());
    var open = manual || forced;
    dir.setAttribute('data-uc-state', forced ? 'forced' : (open ? 'open' : 'closed'));
    btn.setAttribute('aria-expanded', String(open));
  };
  btn.addEventListener('click', function () { manual = !manual; sync(); });
  document.addEventListener('uc:filter', sync);
  if (q) q.addEventListener('input', sync);
  sync();
})();
